// extracted by mini-css-extract-plugin
module.exports = {"skillsList":"SkillsList_skillsList__LPM8b"};